/* @flow */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

import HeaderRow from './headerRow';
import SubHeaderRow from './subHeaderRow';



var roleOrders = [
  'Role: Moderator',
  'Role: Chairman',
  'Role: Judge',
  'Role: Match Referee',
  'Role: Umpire'
];

function sortChairmans(chairmans) {
  chairmans.sort(function (a, b) {
    if (a.lastName === b.lastName) {
      return a.firstName > b.firstName ? 1 : -1;
    } else {
      return a.lastName > b.lastName ? 1 : -1;
    }
  });
  return chairmans;
}


function sortTopics(topics) {
  topics.sort(function (a, b) {
    a.sequence = a.sequence || null;
    b.sequence = b.sequence || null;
    if (a.sequence !== b.sequence) {
      return (a.sequence > b.sequence) ? 1 : -1;
    } else {
      console.log(a.name, b.name);
      return roleOrders.indexOf(a.name) > roleOrders.indexOf(b.name) ? 1 : -1;
    }
  });
  return topics;
}


function formatName(options) {
  options = options || {};
  var names = [];

  if (options.firstName && !options.firstName.trim().isEmpty()) {
    var firstName = options.firstName.trim().toTitleCase();
    if (firstName.indexOf(". ") !== -1) {
      firstName = firstName.replace(". ", ".");
    }
    if (firstName.indexOf("-") !== -1) {
      var firstNames = firstName.split("-");
      firstName = firstNames[0] + "-" + firstNames[1].toLowerCase();
    }
    names.push(firstName);
  }

  // last name
  if (options.lastName && !options.lastName.trim().isEmpty()) {
    names.push(options.lastName.trim().toUpperCase());
  }

  return names.join(" ");
}


function getChairs(session) {
  var chairs=[];
  var chairmans = sortChairmans(session.chairmans);
  chairmans.forEach(function (chairman) {
    var displayName = formatName(chairman);
    chairs.push(<Text text={displayName} />);
  });
  return chairs;
}



class Text extends Component {
  render() {
    return (
      <div className="text">{this.props.text}</div>
    );
  }
}

class Panel extends Component {
  render() {
    var panel = this.props.panel;
    var displayName = formatName(panel);
    return (
      <tr className="">
        <td className="blue">{displayName}</td>
      </tr>
    );
  }
}


class PanelList extends Component {
  render() {
    var list=[];
    var panelists = sortChairmans(this.props.panelists);
    panelists.forEach(function (panel) {
      list.push(<Panel key={panel.id} panel={panel} />);
    });
    return (
      <div className="PanelList">
        <table>
          <tbody>
            <tr className="table_subheader">
              <td>Panelists</td>
            </tr>
            {list}
          </tbody>
        </table>
      </div>
    );
  }
}

class Topic extends Component {
  render() {
    var topic = this.props.topic;
    var displayName = "";

    if (topic.type.toLowerCase().indexOf("discussion") === -1) {
      var speaker = topic.speaker[0];
      if (speaker) {
        displayName = formatName(speaker);
      }
      var topicNames = [];
      topicNames.push(<Text text={topic.name} />);
      if (topic.questionDuration && topic.questionDuration > 0) {
        topicNames.push(<Text text="Q & A" />);
      }
      return (
        <tr className="">
          <td width="20">{topic.sequence}.</td>
          <td>{topicNames}</td>
          <td width="200" className="blue">{displayName}</td>
          <td width="100" className="blue"><i>{topic.startTime} - {topic.endTime}</i></td>
        </tr>
      );
    } else {
      var displayNames = [];
      if (topic.speaker.length > 0) {
        topic.speaker = sortChairmans(topic.speaker);
        topic.speaker.forEach(function (speaker) {
          displayNames.push(formatName(speaker));
        });
      }
      return (
        <tr className="">
          <td width="20">{topic.sequence}.</td>
          <td>{topic.name}</td>
          <td width="200" className="blue">{ ReactHtmlParser(displayNames.join('<br/>')) }</td>
          <td width="100" className="blue"><i>{topic.startTime} - {topic.endTime}</i></td>
        </tr>
      );
    }
  }
}




class TopicList extends Component {
  render() {
    var list=[];
    var topics = sortTopics(this.props.topics);
    topics.forEach(function (topic) {
      list.push(<Topic key={topic._id + '-' + topic.sequence} topic={topic} />);
    });
    return (
      <div className="TopicList">
        <table className="table table-hover table-striped table-bordered">
          <tbody>
            <tr className="header">
              <td colSpan="4">Sequence/Speaker - Topic</td>
            </tr>
            {list}
          </tbody>
        </table>
      </div>
    );
  }
}

export default class sessionDetails extends Component {
  render() {
    var session = this.props.session;
    var chairs = getChairs(session);
    var list = <TopicList topics={session.topics} />;
    // if (session.type.toLowerCase().indexOf("panel") !== -1) {
    //   list = <PanelList panelists={session.topics[0].speaker} />;
    // }
    return (
      <div className="SessionList">
        <table className="table table-bordered table-hover table-striped">
          <tbody>
            <HeaderRow title={session.category} />
            <SubHeaderRow />
            <tr className="">
              <td className="center  blue">{session.date}</td>
              <td className="center nowrap blue">{session.startTime}<br />|<br />{session.endTime}</td>
              <td className="center nowrap venue">{session.venue}</td>
              <td>{session.subspecialty}</td>
              <td>{session.type}</td>
              <td >{session.theme}</td>
              <td className="nowrap">{chairs}</td>
            </tr>
          </tbody>
        </table>
        {list}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/sessionDetails.js
 **/